import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import socialBtns from "../db/socialBtns";
import closeModal from "../assets/images/icons/close-modal.svg";
import copyIcon from "../assets/images/icons/copy-icon.svg";
import { MainContext } from "../utils/MainContext";
import { useTranslation } from "react-i18next";
import { $api } from "../api/api";
import { toastMsg } from "../utils/swal";
import QRCode from "./QRCode";
import { DEFAULT_IMAGES, PROFILE_TYPES } from "../constants/constants";
import { LoginContext } from "../utils/Auth";
import * as ProfileServices from "../Modules/Profile/Service/ProfileService";
import ProfilePhoneNumbersEdit from "../Modules/Profile/View/components/ProfilePhoneNumbersEdit";

const width = window.innerWidth;

const SharedProfileModal = ({ data, isLocal, onClose }) => {
  const { t } = useTranslation();
  const { sharedProfileModal, setSharedProfileModal } = useContext(MainContext);
  const { user } = useContext(LoginContext);
  const [qrCode, setQrCode] = useState("");

  const targetUsername = isLocal ? data?.username : user?.username;
  const targetProfile = isLocal ? data : user?.profile;

  const [showPhonePrompt, setShowPhonePrompt] = useState(false);

  useEffect(() => {
    if (sharedProfileModal) {
      const isOwner = targetUsername === user?.username;
      const hasPhone =
        user?.profile?.phone_number ||
        (user?.profile?.phone_numbers &&
          user?.profile?.phone_numbers?.length > 0);
      if (isOwner && !hasPhone) {
        setShowPhonePrompt(true);
      }
    } else {
      setShowPhonePrompt(false);
    }
  }, [sharedProfileModal, targetUsername, user]);

  const userData = {
    username: targetUsername || "",
    profile_type: targetProfile?.subscription?.tier || "",
    phone_number:
      targetProfile?.phone_number ||
      targetProfile?.phone_numbers?.[0]?.phone_number ||
      "",
    avatar: targetProfile?.avatar || "",
    full_name: targetProfile?.full_name || "",
    background_image: targetProfile?.background_image || "",
    profession: {
      name: targetProfile?.profession?.name || "",
      description: targetProfile?.profession?.description || "",
    },
    bio: targetProfile?.bio || "",
    in_boxes_count: targetProfile?.in_boxes_count || 0,
  };

  useEffect(() => {
    if (sharedProfileModal && targetUsername) {
      ProfileServices.profileFindByUsername(targetUsername)
        .then((res) => {
          if (res?.qr?.svg) {
            setQrCode(res.qr.svg);
          }
        })
        .catch(() => {});
    }
  }, [sharedProfileModal, targetUsername, user]);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      return false;
    }
  };

  const handleCopyClick = () => {
    const url = `${window.location.origin}/shared-user/${userData.username}`;
    if (copyToClipboard(url)) {
      toastMsg(t("sharedUserCard.linkCopied"), "#00ff00", "#fff");
    } else {
      toastMsg(t("sharedUserCard.errorOnCopy"), "#ff0000", "#fff");
    }
  };

  useEffect(() => {
    if (width < 768 && sharedProfileModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [width]);

  const isProUser = user?.profile?.subscription?.tier === PROFILE_TYPES.business || user?.profile?.subscription?.tier === PROFILE_TYPES.personal


  return (
    <div
      className={
        sharedProfileModal ? "sharedProfileModal active" : "sharedProfileModal"
      }
    >
      <div
        className="modalOverlay"
        onClick={() => {
          onClose();
          setSharedProfileModal(false);
        }}
      ></div>
      <div className={sharedProfileModal ? "modalBox addPhone" : "modalBox"}>
        {showPhonePrompt ? (
          <div style={{ width: "100%" }}>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#23272f",
                textAlign: "center",
                textWrap: "wrap",
              }}
            >
              {t("sharedUserCard.completeInfoPrompt")}
            </h3>
            <ProfilePhoneNumbersEdit
              profileData={user?.profile}
              setProfileData={() => {}}
              isProUser={isProUser}
              startInAddMode={true}
              askFullName={true}
              closeModal={() => setShowPhonePrompt(false)}
            />
          </div>
        ) : (
          <>
            <div className="profileInfo">
              <div className="cardTop">
                <div
                  className={`profileImg ${
                    isProUser &&
                    "goldBrd"
                  }`}
                >
                  {userData.avatar ? (
                    <img
                      src={`${
                        userData.avatar.includes("api.")
                          ? ""
                          : $api("image_url") + "/"
                      }${userData.avatar}`}
                      alt={userData.full_name}
                    />
                  ) : (
                    <img src={DEFAULT_IMAGES.avatar_b64} alt="b-icon" />
                  )}
                  {isProUser && (
                    <span className="badge">{t("sharedUserCard.pro")}</span>
                  )}
                </div>
                <div className="profileBanner">
                  <img
                    src={
                      userData?.background_image &&
                      isProUser
                        ? `${
                            userData.background_image.includes("api.")
                              ? ""
                              : $api("image_url") + "/"
                          }${userData.background_image}`
                        : DEFAULT_IMAGES?.background_image_b64
                    }
                    alt={userData.profession.name}
                  />
                </div>
              </div>
              <div className="cardBottom">
                <div className="cardTitle">
                  <div className="title">
                    <div>
                      <p
                        className="fullName"
                        style={{ color: "#23272f", fontWeight: 500 }}
                      >
                        {userData.full_name}
                      </p>
                      {userData.profession.name &&
                        isProUser && (
                          <p className="workInfo">
                            {`${userData.profession.name} ${
                              userData.profession.description !== "Bucard"
                                ? ` ${userData.profession.description}`
                                : ""
                            }`}
                          </p>
                        )}
                      {userData?.bio &&
                        isProUser && (
                          <p className="workInfo">{userData.bio}</p>
                        )}
                      {userData?.phone_number &&
                        !isProUser && (
                          <Link
                            to={`tel:${userData.phone_number}`}
                            className="workInfo"
                          >
                            {userData.phone_number}
                          </Link>
                        )}
                    </div>
                    <p className="inBoxCount">
                      {userData.in_boxes_count} {t("sharedUserCard.boxes")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="qrCode">
              <QRCode qrCodeData={qrCode} />
            </div>
            {false && (
              <ul className="shareSocial">
                {socialBtns.map((item) => (
                  <li className="socialButton" key={item.id}>
                    <Link to={item.url} target="_blank">
                      <img src={item.icon} alt={item.title} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
            <div
              className="link"
              onClick={() => {
                onClose();
                setSharedProfileModal(false);
              }}
            >
              <Link
                to={`${window.location.origin}/shared-user/${userData.username}`}
                className="sharedLink"
              >
                {window.location.origin.replace(
                  window.location.protocol + "//",
                  "",
                )}
                /<span>{userData.username}</span>
              </Link>
              <img
                src={copyIcon}
                alt="copy"
                className="copy"
                onClick={() => {
                  handleCopyClick();
                  onClose();
                  setSharedProfileModal(false);
                }}
              />
            </div>
            <div
              className="closeModal"
              onClick={() => {
                onClose();
                setSharedProfileModal(false);
              }}
            >
              <img src={closeModal} alt="close-icon" />
              <span>{t("addProfileModal.close")}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SharedProfileModal;
